export default "__VITE_ASSET__a8ef8692__"